// extracted by mini-css-extract-plugin
module.exports = {"segment":"segment-module--segment--3sMsf"};